// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__4EmCd","left":"InfoRow_left__j4PwL"};